import { render } from "./userPicture.vue?vue&type=template&id=9ca94318&scoped=true"
import script from "./userPicture.vue?vue&type=script&lang=js"
export * from "./userPicture.vue?vue&type=script&lang=js"

import "./userPicture.vue?vue&type=style&index=0&id=9ca94318&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca94318"]])

export default __exports__